import { push, pushToPixel } from "../services/sendEvent";

export const firePlatformEvent = (data: string[]) => {
	// Call push function with event-label "where_do_you_sell_field_filled" and required payload
	push({
		event_label: "where_do_you_sell_field_filled",
		event_datum: {
			field_information: data
		},
	});
	pushToPixel({
		eventLabel: "Popup-Selling-Source-Filled",
	}, true);
}
